import Vue from "vue";
import Api from "@/service/Api";

const STORAGE_KEY = `site_bootstrap_v5:${window.location.hostname.toLowerCase()}`;

const defaultData = {
  site: {
    site_name: "Tu tienda",
    tagline: "Tu negocio, autogestionable.",
    primary_color: "#2563EB",
    secondary_color: "#111827",
    background_color: "#FFFFFF",
    text_color: "#111827",
    heading_font: "Roboto",
    body_font: "Roboto",
    border_radius: 16,
    button_style: "rounded",
    card_style: "shadow",
    layout_width: "contained",
    store_layout: "classic",
    commerce_mode: "online",
    logo_url: null,
  },
  navigation: [
    { id: "inicio", label: "Inicio", url: "/", enabled: true, sort_order: 10 },
    { id: "nosotros", label: "Nosotros", url: "/nosotros", enabled: true, sort_order: 20 },
    { id: "servicios", label: "Servicios", url: "/servicios", enabled: true, sort_order: 30 },
    { id: "productos", label: "Productos", url: "/productos", enabled: true, sort_order: 40 },
    { id: "contacto", label: "Contacto", url: "/contacto", enabled: true, sort_order: 50 },
  ],
  sections: [],
  modules: [],
  tenant: null,
  capabilities: {
    storefront: true,
    checkout: true,
    external_website: false,
    mercadolibre: false,
    blog: false,
  },
  pages: {},
};

function cachedData() {
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY));
    return value && value.site ? value : defaultData;
  } catch (error) {
    return defaultData;
  }
}

export const siteState = Vue.observable({
  data: cachedData(),
  loading: false,
  loaded: false,
});

let currentRequest = null;

export function setSiteData(data) {
  if (!data || !data.site) return;
  siteState.data = data;
  siteState.loaded = true;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  applyTheme(data.site);
}

export function applyTheme(site) {
  if (!site) return;
  const root = document.documentElement;
  root.style.setProperty("--site-primary", site.primary_color || "#2563EB");
  root.style.setProperty("--site-secondary", site.secondary_color || "#111827");
  root.style.setProperty("--site-bg", site.background_color || "#FFFFFF");
  root.style.setProperty("--site-text", site.text_color || "#111827");
  root.style.setProperty("--site-heading-font", site.heading_font || "Roboto");
  root.style.setProperty("--site-body-font", site.body_font || "Roboto");
  root.style.setProperty("--site-radius", `${Number(site.border_radius || 16)}px`);
  root.style.setProperty("--site-button-radius", site.button_style === "pill" ? "999px" : site.button_style === "square" ? "0px" : `${Number(site.border_radius || 16)}px`);
  root.style.setProperty("--site-content-width", site.layout_width === "full" ? "100%" : "1200px");
  root.dataset.cardStyle = site.card_style || "shadow";
}

export async function loadSiteConfig(force = false) {
  if (currentRequest && !force) return currentRequest;
  siteState.loading = true;

  currentRequest = Api({ redirectOnUnauthorized: false })
    .get("/site/bootstrap")
    .then((response) => {
      setSiteData(response.data);
      return response.data;
    })
    .catch((error) => {
      applyTheme(siteState.data.site);
      return Promise.reject(error);
    })
    .finally(() => {
      siteState.loading = false;
      currentRequest = null;
    });

  return currentRequest;
}

export function getSection(type) {
  return (siteState.data.sections || []).find((item) => item.type === type) || null;
}

export function getCommerceMode() {
  return siteState.data.site?.commerce_mode || "online";
}

export function isCommerceEnabled() {
  return getCommerceMode() === "online";
}

export function arePricesVisible() {
  return getCommerceMode() !== "showcase";
}

applyTheme(siteState.data.site);
